<template>
  <div>

    <Head title="免運費" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <!-- :selection.sync="selectedAdmins"
      sortMode="multiple" -->
    <free-shipping-template>
      <DataTable :value="free_shippings.data" sortMode="multiple" :multiSortMeta.sync="multiSortMeta"
        @sort="onSort($event)">
        <template #header>
          <!-- <div class="flex flex-row justify-between items-center">
          <div
            class="flex flex-row gap-2 items-center"
            v-if="selectedAdmins.length > 0"
          >
            <span> 已選擇 {{ selectedAdmins.length }} 個 </span>
            <span>
              <Dropdown
              :options="batch_action.options"
              v-model="batch_action.selected"
              optionLabel="name"
              optionValue="code"
              placeholder="變更訂單狀態…"
              @change="batchAction"
            />
            </span>
          </div>
          <div v-else></div> -->
          <div class="text-right">
            <Button label="新增活動" @click="addFreeShipping" />
          </div>
          <!-- </div> -->
        </template>

        <!-- <Column headerClass="w-11" selectionMode="multiple"></Column> -->
        <Column header="運送類型" field="delivery_method" sortable>
          <template #body="slotProps">
            <template v-if="slotProps.data.delivery_method == 'regular'">
              一般物流
            </template>
            <template v-else-if="slotProps.data.delivery_method == '711' || slotProps.data.delivery_method == '711_pay'">
              711 店到店
            </template>
            <template v-else>
              其他
            </template>
          </template>
        </Column>
        <Column header="活動名稱" field="description" sortable></Column>
        <Column header="常溫" field="delivery_type.normal" sortable>
          <template #body="slotProps">
            <template v-if="slotProps.data.delivery_type.normal"><i class="pi pi-check" /></template>
          </template>
        </Column>
        <Column header="冷藏" field="delivery_type.refrigerated" sortable>
          <template #body="slotProps">
            <template v-if="slotProps.data.delivery_type.refrigerated"><i class="pi pi-check" /></template>
          </template>
        </Column>
        <Column header="冷凍" field="delivery_type.frozen" sortable>
          <template #body="slotProps">
            <template v-if="slotProps.data.delivery_type.frozen"><i class="pi pi-check" /></template> </template>
        </Column>

        <Column header="免運條件" field="condition.amount" sortable>
          <template #body="slotProps">
            <template v-if="slotProps.data.condition.type == 'always'">
              無限制
            </template>
            <template v-else-if="slotProps.data.condition.type == 'greater'">
              高於
              {{ slotProps.data.condition.amount | commaFormat | priceFormat }}
            </template>
          </template>
        </Column>

        <Column header="活動期間" field="duration.start" sortable>
          <template #body="slotProps">
            <template v-if="slotProps.data.duration.enabled == true">
              {{ formatDate(slotProps.data.duration.start) }} -
              {{ formatDate(slotProps.data.duration.end) }}
            </template>
            <template v-else>無期間限制</template>
          </template>
        </Column>
        <Column headerClass="w-40" header="動作">
          <template #body="slotProps">
            <SplitButton label="編輯" :model="splitButonFunction(slotProps.data)"
              @click="editFreeShipping(slotProps.data.id)"></SplitButton>
          </template>
        </Column>

        <template #empty>沒有任何符合條件的免運活動。</template>
      </DataTable>
    </free-shipping-template>
    <div class="w-full mt-10 flex justify-around">
      <Paginator :page-data="$page.props.free_shippings" />
    </div>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import FreeShippingTemplate from "./Shared/FreeShippingTemplate";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import SelectButton from "primevue/selectbutton";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import SplitButton from "primevue/splitbutton";
import Paginator from "@/Shared/Paginator";

export default {
  layout: Layout,
  components: {
    ScrollTop,
    Breadcrumb,
    FreeShippingTemplate,
    Dialog,
    InputText,
    Password,
    SelectButton,
    Dropdown,
    DataTable,
    Column,
    Button,
    SplitButton,
    Paginator,
  },
  props: {
    free_shippings: Object,
  },
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  data() {
    return {
      breadcrumb_home: {
        label: "行銷管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "免運費",
          to: route("admin.free_shipping"),
          disabled: !decodeURI(this.$page.url).includes("delivery_method"),
        },
        {
          label: this.$page.props.breadcrumb_label,
          disabled: true,
        },
      ],

      filterables: [
        {
          label: "上架中",
          condition: {
            field: "available",
            value: 1,
          },
        },
        {
          label: "未上架",
          condition: {
            field: "available",
            value: 0,
          },
        },
      ],
      selectedFilters: [],
      selectedAdmins: [],
      multiSortMeta: [],
      search: null,
    };
  },
  methods: {
    splitButonFunction(item) {
      return [
        {
          label: "刪除",
          command: () => {
            this.deleteFreeShipping(item.id);
          },
        },
      ];
    },
    addFreeShipping() {
      this.$inertia.visit(
        route("admin.free_shipping.add") +
        "?from=" +
        btoa(encodeURIComponent(this.$page.url))
      );
    },
    editFreeShipping(id) {
      this.$inertia.visit(
        route("admin.free_shipping.edit", id) +
        "?from=" +
        btoa(encodeURIComponent(this.$page.url))
      );
    },
    deleteFreeShipping(id) {
      this.$confirm.require({
        message: "是否確認刪除？",
        header: "刪除確認",
        acceptLabel: "確認刪除",
        rejectLabel: "不要刪除",
        accept: () => {
          this.$inertia.delete(
            route("admin.free_shipping.delete", id) +
            "?from=" +
            encodeURIComponent(this.$page.url),
            {
              preserveScroll: true,
              preserveState: true,
              only: ["free_shippings"],
            }
          );
        },
        reject: () => {
          //
        },
      });
    },
    deliveryString(delivery) {
      switch (delivery) {
        case "normal":
          return "常溫商品";
          break;
        case "refrigerated":
          return "冷藏商品";
          break;
        case "frozen":
          return "冷凍商品";
          break;
      }
    },
    formatDate(dateString) {
      let date = new Date(dateString);
      return (
        date.getFullYear() +
        "/" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        date.getDate().toString().padStart(2, "0") +
        " " +
        date.getHours().toString().padStart(2, "0") +
        ":" +
        date.getMinutes().toString().padStart(2, "0") +
        ":" +
        date.getSeconds().toString().padStart(2, "0")
      );
    },
    getQueryStrings() {
      let queryStr = window.location.search,
        queryArr = queryStr.replace("?", "").split("&"),
        queryParams = [];

      for (let q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        let qArr = queryArr[q].split("=");
        queryParams[qArr[0]] = qArr[1];
      }

      return _(queryParams).omitBy(_.isUndefined).omitBy(_.isNull).value();
    },
    onSearch: _.debounce(function () {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["search"] = this.search;

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    }, 1000),
    onSort(event) {
      let queryStringArray = this.getQueryStrings();

      queryStringArray["sort"] = JSON.stringify(event.multiSortMeta);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["free_shippings"],
      });
    },
    onFilter(event) {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["filter"] = JSON.stringify(event.value);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    },
  },
  mounted() {
    if (this.getQueryStrings()["sort"]) {
      this.multiSortMeta = JSON.parse(
        decodeURI(this.getQueryStrings()["sort"])
      );
    }

    if (this.getQueryStrings()["search"]) {
      this.search = decodeURI(this.getQueryStrings()["search"]);
    }

    if (this.getQueryStrings()["filter"]) {
      let selected = JSON.parse(decodeURI(this.getQueryStrings()["filter"]));

      _.forIn(this.filterables, (item) => {
        let found = _.find(selected, item.condition);
        if (found) {
          this.selectedFilters.push(found);
        }
      });
    }
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}
</style>